module.exports = __webpack_public_path__ + "assets/date.46b22f64.svg";